import { render } from "./ChallengeRecentChallenges.vue?vue&type=template&id=1e82e0d8&scoped=true"
import script from "./ChallengeRecentChallenges.vue?vue&type=script&lang=js"
export * from "./ChallengeRecentChallenges.vue?vue&type=script&lang=js"

import "@/css/components/challenge-recent-challenges.css?vue&type=style&index=0&id=1e82e0d8&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e82e0d8"]])

export default __exports__